import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiLanguageComponent } from '../multi-language.component';
import { MaterialsModule } from '../../../modules/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../../../../../../environments/environment';



@NgModule({
  declarations: [MultiLanguageComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  exports:[MultiLanguageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MultiLanguageModule { }

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.multiLanguage, '.json');
}
